module.exports = __webpack_public_path__ + "img/bingo_ball-52.3f0d5d94.png";